import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import index from '@/pages/index'
import login from '@/pages/login/login'
import profile from '@/pages/profile/index'
import goodsDetail from '@/pages/goods/goodsDetail'
import goodsList from '@/pages/goods/goodsList'
import stores from '@/pages/stores/index.vue'
import faq from '@/pages/faq/index.vue'
import orderDetail from '@/pages/order/orderDetail'
import orderConfirm from '@/pages/order/orderConfirm'
import orderList from '@/pages/order/orderList'
import payResult from '@/pages/payment/result'
import checkout from '@/pages/payment/checkout'
import codSuccess from '@/pages/payment/codSuccess'
import offlinePickupSuccess from '@/pages/payment/offlinePickupSuccess'
import codShippingFeeCheckout from '@/pages/payment/codShippingFeeCheckout'
import storePaymentCheckout from '@/pages/payment/storePaymentCheckout'
import breachCheckout from '@/pages/payment/breachCheckout'
import repayCheckout from '@/pages/payment/repayCheckout'
import rentalplanList from '@/pages/rentalplan/planList'
import rentalplanDetail from '@/pages/rentalplan/planDetail'
import terminate from '@/pages/rentalplan/terminate'
import agreement from '@/pages/agreement/index.vue'
import additionalInfo from '@/pages/additionalInfo/index.vue'
import additionalInfoSubmitSuccess from '@/pages/additionalInfo/submitSuccess.vue'
import addressContacts from '@/pages/addressContacts/index.vue'
import personalAdditionalInfo from '@/pages/personalAdditionalInfo/index.vue'
import profileSettings from '@/pages/profile/settings.vue'
import profileAboutUs from '@/pages/profile/aboutUs.vue'
import profileDeleteAccount from '@/pages/profile/deleteAccount.vue'
import profileDeleteAccountSuccess from '@/pages/profile/deleteAccountSuccess.vue'
import paymentMethods from '@/pages/payment/methods.vue'
import ktpCamera from '@/pages/kyc/ktpCamera.vue'
import { getAppSystemConfig } from '@/api/common'
import { DEFAULT_REG_CHANNEL } from '@/config'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/rental-h5',
  routes: [
    {
      name: 'IndexBase',
      path: '',
      component: index,
      meta: { keepAlive: true }
    },
    {
      name: 'Index',
      path: '/index',
      component: index,
      meta: { keepAlive: true }
    },
    {
      name: 'Profile',
      path: '/profile/index',
      component: profile
    },
    {
      name: 'ProfileSettings',
      path: '/profile/settings',
      component: profileSettings
    },
    {
      name: 'ProfileAboutUs',
      path: '/profile/about-us',
      component: profileAboutUs
    },
    {
      name: 'ProfileDeleteAccount',
      path: '/profile/delete-account',
      component: profileDeleteAccount
    },
    {
      name: 'ProfileDeleteAccountSuccess',
      path: '/profile/delete-account/success',
      component: profileDeleteAccountSuccess
    },
    {
      name: 'Login',
      path: '/login',
      component: login,
      meta: { keepAlive: true }
    },
    {
      name: 'GoodsDetail',
      path: '/goods/detail',
      component: goodsDetail
    },
    {
      name: 'GoodsList',
      path: '/goods/list',
      component: goodsList
    },
    {
      name: 'Stores',
      path: '/stores',
      component: stores
    },
    {
      name: 'Faq',
      path: '/faq',
      component: faq
    },
    {
      name: 'OrderDetail',
      path: '/order/detail',
      component: orderDetail
    },
    {
      name: 'OrderConfirm',
      path: '/order/confirm',
      component: orderConfirm,
      meta: { requiresAuth: true }
    },
    {
      name: 'OrderDetailAuth',
      path: '/order/detail/:authType',
      component: orderDetail
    },
    {
      name: 'OrderList',
      path: '/order/list',
      component: orderList,
      meta: { keepAlive: true }
    },
    {
      name: 'PaymentResult',
      path: '/payment/result',
      component: payResult
    },
    {
      name: 'Checkout',
      path: '/payment/checkout',
      component: checkout,
      meta: { requiresAuth: true }
    },
    {
      name: 'CodSuccess',
      path: '/payment/cod-success',
      component: codSuccess,
      meta: { requiresAuth: true }
    },
    {
      name: 'OfflinePickupSuccess',
      path: '/payment/offline-pickup-success',
      component: offlinePickupSuccess,
      meta: { requiresAuth: true }
    },
    {
      name: 'CodShippingFeeCheckout',
      path: '/payment/cod-shipping-fee-checkout',
      component: codShippingFeeCheckout,
      meta: { requiresAuth: true }
    },
    {
      name: 'StorePaymentCheckout',
      path: '/payment/store-checkout',
      component: storePaymentCheckout,
      meta: { requiresAuth: true }
    },
    {
      name: 'BreachCheckout',
      path: '/payment/breach-checkout',
      component: breachCheckout,
      meta: { requiresAuth: true }
    },
    {
      name: 'RepayCheckout',
      path: '/payment/repay-checkout',
      component: repayCheckout,
      meta: { requiresAuth: true }
    },
    {
      name: 'PaymentMethods',
      path: '/payment/methods',
      component: paymentMethods,
      meta: { requiresAuth: true }
    },
    {
      name: 'RentalplanList',
      path: '/rentalplan/list',
      component: rentalplanList
    },
    {
      name: 'RentalplanDetail',
      path: '/rentalplan/detail',
      component: rentalplanDetail
    },
    {
      name: 'Terminate',
      path: '/rentalplan/terminate',
      component: terminate
    },
    {
      name: 'Agreement',
      path: '/agreement/index',
      component: agreement,
      meta: {
        title: '协议'
      }
    },
    {
      name: 'AdditionalInfo',
      path: '/additional-info',
      component: additionalInfo
    },
    {
      name: 'AdditionalInfoSubmitSuccess',
      path: '/additional-info-submit-success',
      component: additionalInfoSubmitSuccess
    },
    {
      name: 'PersonalAdditionalInfo',
      path: '/personal-additional-info',
      component: personalAdditionalInfo,
      meta: { requiresAuth: true }
    },
    {
      name: 'KtpCamera',
      path: '/kyc/ktp-camera',
      component: ktpCamera,
      meta: { requiresAuth: true }
    },
    {
      name: 'AddressContacts',
      path: '/address-contacts',
      component: addressContacts,
      meta: { requiresAuth: true }
    },
  ]
})

// 历史记录键名
const HISTORY_KEY = 'pageHistory'

// 检查路径是否匹配（包括动态路由）
const isRouteMatch = (path, routePath) => {
  // 只比较路径部分，忽略 query 参数
  const pathOnly = path.split('?')[0]
  const routePathOnly = routePath.split('?')[0]

  if (pathOnly === routePathOnly) return true
  if (routePathOnly.includes(':')) {
    const pattern = routePathOnly.replace(/:[^/]+/g, '[^/]+')
    const regex = new RegExp(`^${pattern}$`)
    return regex.test(pathOnly)
  }
  return false
}

// 获取路径部分（不含 query）
const getPathOnly = (path) => path.split('?')[0]

const FIRST_PAGE_PATHS = {
  home: '/index',
  login: '/login'
}

const normalizeFirstPage = (value) => {
  const normalized = String(value || '').trim().toLowerCase()
  return normalized === 'login' ? 'login' : 'home'
}

let guestFirstPagePromise = null
let guestFirstPage = ''
let guestFirstPageChecked = false

const getGuestFirstPage = async () => {
  if (guestFirstPage) return guestFirstPage
  if (!guestFirstPagePromise) {
    guestFirstPagePromise = getAppSystemConfig({ platform: 'h5', channel: store.state.user.channel || DEFAULT_REG_CHANNEL })
      .then((res) => {
        guestFirstPage = normalizeFirstPage(res?.data?.features?.firstPage ?? res?.data?.firstPage)
        return guestFirstPage
      })
      .catch(() => {
        guestFirstPage = 'home'
        return guestFirstPage
      })
      .finally(() => {
        guestFirstPagePromise = null
      })
  }
  return guestFirstPagePromise
}

const guestRoutePaths = [
  '/',
  '/login',
  '/index',
  '/goods/list',
  '/goods/detail',
  '/profile/index',
  '/profile/settings',
  '/profile/about-us',
  '/profile/delete-account',
  '/profile/delete-account/success',
  '/stores',
  '/faq',
  '/agreement/index'
]

const isThirdPartyOrderDetailReturn = (path = '') => {
  const [pathOnly, queryString = ''] = String(path).split('?')
  if (pathOnly !== '/order/detail' || !queryString) return false
  const params = new URLSearchParams(queryString)
  return params.get('fromThirdParty') === '1' && !params.get('orderId')
}

const isPaymentRoute = (path = '') => getPathOnly(String(path)).startsWith('/payment/')

const removePaymentHistoryEntries = (history = []) => history.filter(item => !isPaymentRoute(item))

// 添加到历史栈
const addToHistory = (path, toPath) => {
  if (!path || getPathOnly(path) === '/') return
  if (isThirdPartyOrderDetailReturn(path)) return

  let history = JSON.parse(sessionStorage.getItem(HISTORY_KEY) || '[]')

  // 检查目标页面是否在我们的历史中（返回导航），如果是则移除当前页面之后的所有记录
  if (toPath) {
    const toPathOnly = getPathOnly(toPath)
    let existingIndex = -1

    for (let i = 0; i < history.length; i++) {
      if (isRouteMatch(toPathOnly, getPathOnly(history[i]))) {
        existingIndex = i
        break
      }
    }

    if (existingIndex !== -1) {
      history = history.slice(0, existingIndex + 1)
      sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history))
      return
    }
  }

  // 避免重复添加相邻的相同页面（只比较路径部分）
  if (history.length === 0 || getPathOnly(history[history.length - 1]) !== getPathOnly(path)) {
    history.push(path)  // 保存完整路径，包括 query 参数
    if (history.length > 20) history.shift()
    sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history))
  }
}

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  if (to.path === '/order/detail' && !to.query.orderId && String(to.query.fromThirdParty || '') !== '1') {
    next('/order/confirm')
    return
  }

  // 检查是否是回退操作
  const isGoBack = sessionStorage.getItem('isGoBack')

  if (isGoBack === 'true') {
    sessionStorage.removeItem('isGoBack')
  } else if (from.path) {
    // 记录历史（使用 fullPath 包含 query 参数）
    const fromPath = from.fullPath || from.path
    const toPath = to.fullPath || to.path
    // 收银台是支付流程中的中间页。支付完成或主动返回后，不应把它重新压回历史，
    // 否则订单详情返回时会再次进入收银台，形成详情页和收银台之间的循环。
    if (isPaymentRoute(fromPath) && !isPaymentRoute(toPath)) {
      const history = removePaymentHistoryEntries(JSON.parse(sessionStorage.getItem(HISTORY_KEY) || '[]'))
      sessionStorage.setItem(HISTORY_KEY, JSON.stringify(history))
    } else {
      addToHistory(fromPath, toPath)
    }
  }

  // 处理 regChannel 参数
  const channel = to.query.regChannel
  if (channel) {
    store.commit('user/SET_CHANNEL', channel)
  }

  const isLoggedIn = store.state.user.session.accessToken
  if (!isLoggedIn && !guestFirstPageChecked) {
    guestFirstPageChecked = true
    const firstPage = await getGuestFirstPage()
    const targetPath = FIRST_PAGE_PATHS[firstPage] || FIRST_PAGE_PATHS.home
    if (getPathOnly(to.path) !== targetPath) {
      next({
        path: targetPath,
        query: to.query,
        replace: true
      })
      return
    }
  }

  if (!guestRoutePaths.includes(to.path) && !isLoggedIn) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  next()
})

export default router;
